export const TEST_IDS = {
  nav: {
    home: "nav-home",
    radios: "nav-radios",
    music: "nav-music",
    videos: "nav-videos",
    library: "nav-library",
    discover: "nav-discover",
    login: "nav-login",
    logout: "nav-logout",
    brand: "nav-brand",
  },
  home: {
    heroCta: "home-hero-cta",
    exploreRadios: "home-explore-radios",
    exploreVideos: "home-explore-videos",
  },
  radio: {
    searchInput: "radio-search-input",
    countrySelect: "radio-country-select",
    tagSelect: "radio-tag-select",
    langSelect: "radio-language-select",
    playBtn: "radio-play-button",
    favBtn: "radio-fav-button",
    stationCard: "radio-station-card",
  },
  video: {
    searchInput: "video-search-input",
    searchBtn: "video-search-button",
    card: "video-card",
    playBtn: "video-play-button",
    favBtn: "video-fav-button",
    addPlaylistBtn: "video-add-playlist-button",
  },
  player: {
    bar: "player-bar",
    play: "player-play",
    pause: "player-pause",
    stop: "player-stop",
    expand: "player-expand",
    volume: "player-volume",
    sleep: "player-sleep",
    alarm: "player-alarm",
    alarmSave: "player-alarm-save",
  },
  library: {
    radios: "library-radios-tab",
    videos: "library-videos-tab",
    tracks: "library-tracks-tab",
    playlists: "library-playlists-tab",
    history: "library-history-tab",
    recommendations: "library-recommendations-tab",
    alarms: "library-alarms-tab",
    createPlaylist: "library-create-playlist",
    shareToggle: "library-share-toggle",
    copyShare: "library-copy-share",
    reorderUp: "library-reorder-up",
    reorderDown: "library-reorder-down",
  },
  auth: {
    googleLogin: "google-login-button",
  },
};
